import { Box, Typography } from "@mui/material";
import { DeleteImpactResponse } from "../../shared/interfaces/delete-impact";

interface DeleteImpactContentProps {
    entityLabel: string;
    impact: DeleteImpactResponse | null;
    isLoading?: boolean;
}

export function DeleteImpactContent({
    entityLabel,
    impact,
    isLoading = false,
}: DeleteImpactContentProps) {
    if (isLoading) {
        return (
            <Typography>
                Carregando projetos vinculados...
            </Typography>
        );
    }

    const linkedProjects = impact?.linkedProjects || [];

    if (linkedProjects.length === 0) {
        return (
            <Typography>
                Tem certeza que deseja excluir este {entityLabel}? Esta ação não pode ser desfeita.
            </Typography>
        );
    }

    return (
        <Box>
            <Typography sx={{ mb: 1.5 }}>
                Este {entityLabel} está vinculado aos projetos abaixo. Se você continuar, ele será removido desses projetos antes da exclusão.
            </Typography>
            <Box component="ul" sx={{ pl: 2.5, mb: 0 }}>
                {linkedProjects.map((project) => (
                    <Box component="li" key={project.id} sx={{ mb: 1 }}>
                        <Typography sx={{ fontWeight: 600 }}>
                            {project.name}
                        </Typography>
                        {project.linkTypes.length > 0 && (
                            <Typography variant="body2" color="text.secondary">
                                {project.linkTypes.join(", ")}
                            </Typography>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
